<template>
  <v-list-tile v-bind:class="[groupStylingClass, indentedClass]" :key="item.title" :to="item.route" :aria-label="item.title">
              <v-list-tile-action v-if="item.iconSet">
                <font-awesome-icon size="1x" :icon="[item.iconSet, item.iconCode]"></font-awesome-icon>
              </v-list-tile-action>
      <v-list-tile-title>{{ item.title }}</v-list-tile-title>
    <v-btn v-if="!isBookmrked" @click.prevent="createBookmark(item)" class="bookmark-button" icon>
      <v-icon>bookmark</v-icon>
    </v-btn>
    <v-btn v-if="isBookmrked" @click.prevent="removeBookmark()" class="bookmark-button" icon>
      <v-icon color="primary">bookmark</v-icon>
    </v-btn>
  </v-list-tile>
</template>

<script>
import Helpers from "@/helpers.js"
import inflection from 'inflection'
import { mapState } from "vuex"

export default {
  name: "LeafNode",
  props: {
    item: { type: Object },
    isChildItem: { type: Boolean, default: false }
  },
  data: () => {
    return {
      groupStylingClass: "no-group-styling",
      caseTypeMenuOptions: ["Summary", "Schema", "Tasks", "Relationships", "Permissions", "Documents", "Status", "Scripts", "Emails"]
    }
  },
  computed: {
    ...mapState({
      bookmarks: state => state.ui.caseWorkMenu && state.ui.caseWorkMenu[0].items && state.ui.caseWorkMenu[0].items[0] && state.ui.caseWorkMenu[0].items[0].childItems && state.ui.caseWorkMenu[0].items[0].childItems ? state.ui.caseWorkMenu[0].items[0].childItems : [],
      currentBucket: state => state.buckets.current
    }),
    isBookmrked() {
      const links = this.bookmarks.map(bookmark => bookmark.route)
      // Check if current route matches item route, and if so, also check fullPath for querystring matches
      if (this.$route && this.$route.path === this.item.route) {
        return links.includes(this.item.route) || links.includes(this.$route.fullPath)
      }
      return (links.includes(this.item.route))
    },
    indentedClass() {
      return this.isChildItem ? "" : "indented"
    }
  },
  methods: {
    async createBookmark(data) {
      let linkText = data.title
      const routeParts = data.route.split('/')
      if (data.title === "Overview") {
        if (routeParts.includes("case-types")) {
          linkText = this.attachCaseType(parseInt(routeParts[2]), "Overview")
        } else {
          linkText = await this.$store.dispatch("handleOverviewRoute", data.route)
        }
      } else {
        if (this.caseTypeMenuOptions.includes(data.title)) {
          linkText = this.attachCaseType(parseInt(routeParts[3]), data.title)
        }
      }
      // Use fullPath if current route matches the item route to preserve querystring
      const routeToBookmark = this.$route.path === data.route ? this.$route.fullPath : data.route
      this.$store.dispatch("createBookmark", { route: routeToBookmark, linkText: linkText })
      this.checkAndUpdateBucketBookmark(data)
    },
    removeBookmark() {
      // Use fullPath if current route matches the item route to match stored bookmark
      const routeToMatch = this.$route.path === this.item.route ? this.$route.fullPath : this.item.route
      const bm = this.bookmarks.find(bookmark => bookmark.route === routeToMatch)
      if (bm) {
        this.$store.dispatch("deleteBookmark", { id: bm.id })
        this.checkAndUpdateBucketBookmark(bm)
      } else {
        this.$store.commit("displayFlashMessage", { message: "ID not found, cannot delete..", severity: "error" })
      }
    },
    checkAndUpdateBucketBookmark(bm) {
      const routeParts = bm.route.split('/')
      if (routeParts.length === 5) {
        if (routeParts[1] === 'case-types' && routeParts[3] === 'buckets') {
          if (parseInt(routeParts[4]) === this.currentBucket.bucket.id) {
            this.$store.commit('setBucketBookmarked', !this.currentBucket.bookmarked)
          }
        }
      }
    },
    attachCaseType(id, link) {
      if (id && id > 0) {
        const caseType = Helpers.getCaseTypeById(this.$store.state, id)
        if (caseType && caseType.name) {
          return inflection.pluralize(caseType.name) + " " + link
        } else {
          return "CaseType " + id + "'s " + link // CaseType not found!
        }
      }
    }
  }
}
</script>
